import { Route, Routes } from "react-router-dom"
import AgencyUserList from "./components/AgencyUserList"

export default function AgencyUsersPage() {
  return (
    <Routes>
      <Route index element={<AgencyUserList />} />
    </Routes>
  )
}
